const SUFFIXES = ['', 'K', 'M', 'B', 'T', 'Qa', 'Qi'];

// Compact display for game numbers: 950, 1.2K, 34.5M ...
export function formatNumber(value, decimals = 1) {
  if (value < 1000) {
    return Number.isInteger(value) ? String(value) : value.toFixed(decimals);
  }
  const tier = Math.min(Math.floor(Math.log10(value) / 3), SUFFIXES.length - 1);
  const scaled = value / Math.pow(1000, tier);
  return `${parseFloat(scaled.toFixed(decimals))}${SUFFIXES[tier]}`;
}

export function spriteUrl(icon) {
  return `${process.env.PUBLIC_URL}/sprites/${icon}.png`;
}
